module.exports = __webpack_public_path__ + "static/media/Screenshot_2026-02-10_at_11.29.31-removebg-preview.57198eca.png";